import React from 'react';

var ColBodyInner = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'inside-inner-wrapper' }, children);
};

export { ColBodyInner };
